import { guideSteps } from '@/mocks/home';

export default function OnlineGuide() {
  return (
    <section id="online" className="w-full bg-secondary-50">
      <div className="mx-auto max-w-[1280px] px-4 py-14 md:px-6 md:py-20">
        <div className="mx-auto max-w-2xl text-center">
          <span className="font-label text-xs tracking-[0.2em] text-accent-700">ONLINE / 在线看</span>
          <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            小蓝视频在线看的使用方法
          </h2>
          <p className="mt-3 text-sm leading-7 text-foreground-600">
            不想安装安装包时，网页端同样可以浏览。按下面四步操作，从打开入口到开始浏览通常不超过一分钟。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4 lg:gap-5">
          {guideSteps.map((step, index) => (
            <div key={step.step} className="relative rounded-lg border border-background-200 bg-background-50 p-5 md:p-6">
              <div className="flex items-center justify-between">
                <span className="font-heading text-3xl font-black text-background-300 md:text-4xl">{step.step}</span>
                <span className="flex h-11 w-11 items-center justify-center rounded-full bg-accent-100 text-accent-700">
                  <i className={`${step.icon} text-xl`} />
                </span>
              </div>
              <h3 className="mt-5 font-heading text-base font-semibold text-foreground-950 md:text-lg">{step.title}</h3>
              <p className="mt-2 text-xs leading-6 text-foreground-600 md:text-sm">{step.desc}</p>
              {index < guideSteps.length - 1 && (
                <span className="absolute -right-3 top-1/2 hidden h-6 w-6 -translate-y-1/2 items-center justify-center rounded-full border border-background-200 bg-background-50 text-foreground-400 lg:flex">
                  <i className="ri-arrow-right-s-line text-base" />
                </span>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}